import gql from 'graphql-tag'
import { LOCATION_DRAWING_FIELDS } from './fragments'

// LocationDrawing

export const CREATE_LOCATION_DRAWING_MUTATION = gql`
    mutation createLocationDrawing($projectId: ID!, $file: FileId!, $name: String!) {
        createLocationDrawing(input: { project: $projectId, file: $file, name: $name }) {
            locationDrawing {
                ...LocationDrawingFields
            }
        }
    }
    ${LOCATION_DRAWING_FIELDS}
`

export const SET_LOCATION_DRAWING_IS_ARCHIVED_MUTATION = gql`
    mutation setLocationDrawingIsArchived($id: ID!, $isArchived: Boolean!) {
        setLocationDrawingIsArchived(input: { id: $id, isArchived: $isArchived }) {
            locationDrawing {
                ...LocationDrawingFields
            }
        }
    }
    ${LOCATION_DRAWING_FIELDS}
`

export const SET_LOCATION_DRAWING_NAME_MUTATION = gql`
    mutation setLocationDrawingName($id: ID!, $name: String!) {
        setLocationDrawingName(input: { id: $id, name: $name }) {
            locationDrawing {
                ...LocationDrawingFields
            }
        }
    }
    ${LOCATION_DRAWING_FIELDS}
`

export const SET_LOCATION_DRAWING_DESCRIPTION_MUTATION = gql`
    mutation setLocationDrawingDescription($id: ID!, $description: RichText!) {
        setLocationDrawingDescription(input: { id: $id, description: $description }) {
            locationDrawing {
                ...LocationDrawingFields
            }
        }
    }
    ${LOCATION_DRAWING_FIELDS}
`
